
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labs/[author]/qna",
      function () {
        return require("private-next-pages/labs/[author]/qna/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labs/[author]/qna"])
      });
    }
  